import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  sessionNotification: null,
  sessionNotificationError: "",
  formError: "",
};

export default function SessionNotificationReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADING_SESSION_NOTIFICATION:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_SESSION_NOTIFICATION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_SESSION_NOTIFICATION:
      return {
        ...state,
        sessionNotification: action.payload,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.SESSION_NOTIFICATION_FAIL:
      return { ...state, sessionNotificationError: action.payload };
    default:
      return state;
  }
}
